export const procesos = [
    {
        id: "proceso-1",
        nombre: "Proyecto Contra Incendio",
        documentos: [
            {
                id: 1,
                titulo: "01-01-FORMATO DE MEMORIA TECNICA PARA VISTO BUENO CONTRA INCENDIO",
                archivo: "01-visto-bueno/01-01-FORMATO-DE-MEMORIA-TECNICA-VISTO-BUENO-CONTRA-INCENDIO.docx",
                tipo: "Word",
                tipoFormato: "Memoria Técnica",
                color: "blue",
                descripcion: "Formato requerido para la obtención del Visto Bueno de Proyecto contra Incendio."
            },
            {
                id: 2,
                titulo: "01-02-PRESENTACION DE PLANOS PARA VISTO BUENO DE PROYECTO CONTRA INCENDIO",
                archivo: "01-visto-bueno/01-02-PRESENTACION-PLANOS-VISTO-BUENO-CONTRA-INCENDIO.docx",
                tipo: "Word",
                tipoFormato: "Presentación de Planos",
                color: "blue",
                descripcion: "Formato requerido para la obtención del Visto Bueno de Proyecto contra Incendio."
            }
        ]
    },
    {
        id: "proceso-2",
        nombre: "Plan de Autoprotección",
        documentos: [
            {
                id: 3,
                titulo: "02-01-FORMATO DE PLAN DE AUTOPROTECCION",
                archivo: "02-plan-autoproteccion/02-01-FORMATO-PLAN-AUTOPROTECCION.docx",
                tipo: "Word",
                tipoFormato: "Plan de Autoprotección",
                color: "blue",
                descripcion: "Formato requerido para la obtención del Informe Favorable de Plan de Autoprotección."
            },
            {
                id: 4,
                titulo: "02-03-TABLA DE FACTOR DE OCUPACION (NFPA 101)",
                archivo: "02-plan-autoproteccion/02-03-TABLA-FACTOR-OCUPACION-NFPA-101.docx",
                tipo: "Word",
                tipoFormato: "Formato de Autoprotección",
                color: "blue",
                descripcion: "Formato requerido para la obtención del Informe Favorable de Plan de Autoprotección."
            },
            {
                id: 5,
                titulo: "02-04-METODO MESERI (MAPFRE)",
                archivo: "02-plan-autoproteccion/02-04-METODO-MESERI-MAPFRE.xlsx",
                tipo: "Excel",
                tipoFormato: "Solicitud",
                color: "green",
                descripcion: "Formato requerido para la obtención del Informe Favorable de Plan de Autoprotección."
            },
            {
                id: 6,
                titulo: "02-05-METODO MESERI JESUS PEREZ OBESO",
                archivo: "02-plan-autoproteccion/02-05-METODO-MESERI-JESUS-PEREZ-OBESO.xlsx",
                tipo: "Excel",
                tipoFormato: "Certificado",
                color: "green",
                descripcion: "Formato requerido para la obtención del Informe Favorable de Plan de Autoprotección."
            }
        ]
    },
    {
        id: "proceso-3",
        nombre: "Factibilidad de GLP",
        documentos: [
            {
                id: 7,
                titulo: "03-01-FORMATO DE MEMORIA TECNICA GLP",
                archivo: "03-glp/03-01-FORMATO-MEMORIA-TECNICA-GLP.docx",
                tipo: "Word",
                tipoFormato: "Memoria Técnica",
                color: "blue",
                descripcion: "Formato requerido para la obtención del informe de Factibilidad de GLP."
            }
        ]
    }
];